const useWindow = (): Window | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window;
};

export default useWindow;
